// GPSPermissionModal.jsx - Force GPS enable before app access
import React, { useState, useEffect } from 'react';
import './GPSPermissionModal.css';

function GPSPermissionModal({ onLocationGranted }) {
  const [status, setStatus] = useState('requesting'); // requesting, denied, error, granted
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    requestLocation();
  }, []);

  const requestLocation = () => {
    setStatus('requesting');
    
    if (!navigator.geolocation) {
      setStatus('error');
      setErrorMessage('GPS not supported on this device');
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const coords = {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          accuracy: position.coords.accuracy,
          timestamp: new Date()
        };
        setStatus('granted');
        onLocationGranted(coords);
      },
      (error) => {
        setStatus('denied');
        if (error.code === 1) {
          setErrorMessage('Location permission denied. Please enable GPS to use this app.');
        } else if (error.code === 2) {
          setErrorMessage('Location unavailable. Please check your GPS settings.');
        } else {
          setErrorMessage('Unable to retrieve location. Please try again.');
        }
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0
      }
    );
  };

  if (status === 'granted') return null;

  return (
    <div className="gps-modal-overlay">
      <div className="gps-modal">
        <div className="gps-modal-icon">
          {status === 'requesting' && '📍'}
          {status === 'denied' && '🚫'}
          {status === 'error' && '⚠️'}
        </div>

        <h2 className="gps-modal-title">
          {status === 'requesting' && 'Enable Location Access'}
          {status === 'denied' && 'Location Required'}
          {status === 'error' && 'GPS Error'}
        </h2>

        <p className="gps-modal-message">
          {status === 'requesting' && 'Please allow location access to use the DileX Field Operations app. We need your GPS coordinates for service tracking and verification.'}
          {(status === 'denied' || status === 'error') && errorMessage}
        </p>

        {status === 'requesting' && (
          <div className="gps-loading">
            <div className="gps-spinner"></div>
            <p>Waiting for GPS permission...</p>
          </div>
        )}

        {(status === 'denied' || status === 'error') && (
          <div className="gps-modal-actions">
            <button onClick={requestLocation} className="btn-retry">
              🔄 Try Again
            </button>
            <p className="gps-help-text">
              💡 <strong>How to enable:</strong><br/>
              Settings → Apps → Browser/DileX → Permissions → Location → Allow
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default GPSPermissionModal;
